import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  pt: {
    // Navigation
    nav: {
      home: 'Início',
      gallery: 'Galeria',
      about: 'Sobre Mim',
      services: 'Serviços',
      contact: 'Contacto',
      book: 'Agendar Sessão'
    },
    // Hero
    hero: {
      subtitle: 'Fotografia de Família',
      title: 'Momentos que',
      titleAccent: 'ganham vida',
      description: 'Capturo a essência da sua família com elegância e sensibilidade. Cada sessão é uma experiência única, criada para preservar memórias preciosas.',
      cta: 'Ver Portfólio',
      ctaSecondary: 'Agendar Sessão'
    },
    // Services
    services: {
      title: 'Serviços',
      subtitle: 'O que posso fazer por si',
      family: {
        title: 'Sessões de Família',
        description: 'Momentos autênticos em família, capturados com naturalidade e carinho. Ideal para criar memórias que durarão gerações.'
      },
      newborn: {
        title: 'Recém-Nascidos',
        description: 'Os primeiros dias do seu bebé merecem ser eternizados. Sessões delicadas e seguras para os mais pequenos.'
      },
      maternity: {
        title: 'Gravidez',
        description: 'Celebre a beleza da maternidade. Sessões elegantes que capturam este momento mágico da sua vida.'
      },
      baptism: {
        title: 'Batizados e Comunhões',
        description: 'Registe os momentos especiais das celebrações religiosas da sua família com fotografia documental.'
      }
    },
    // About
    about: {
      title: 'Sobre Mim',
      subtitle: 'A minha história',
      greeting: 'Olá, sou a Vera',
      story: `Desde pequena que a fotografia me fascina. O poder de congelar um momento no tempo, de preservar emoções e criar memórias tangíveis sempre me encantou.

Há um ano que realizei o meu sonho de abrir o meu próprio estúdio, e cada sessão continua a emocionar-me como a primeira. Acredito que as melhores fotografias nascem da conexão genuína entre o fotógrafo e os seus clientes.

O meu estúdio, localizado na Atalaia, Montijo, é um espaço acolhedor onde as famílias se podem sentir à vontade para serem autênticas. Aqui, não existem poses forçadas – apenas momentos reais, capturados com sensibilidade e arte.

A minha missão é criar imagens que contam histórias, que emocionam e que serão tesouros para as gerações futuras. Cada família é única, e o meu trabalho é revelar essa singularidade através da lente da minha câmara.`,
      experience: 'Anos de Experiência',
      families: 'Famílias Fotografadas',
      sessions: 'Sessões Realizadas',
      dedication: 'Dedicação',
      uniqueSession: 'Sessão é Única',
      memoriesForever: 'Memórias para Sempre'
    },
    // Gallery
    gallery: {
      title: 'Galeria',
      subtitle: 'O meu trabalho',
      all: 'Todas',
      family: 'Família',
      newborn: 'Recém-Nascidos',
      maternity: 'Gravidez',
      baptism: 'Batizados'
    },
    // Contact
    contact: {
      title: 'Contacto',
      subtitle: 'Vamos conversar',
      intro: 'Estou aqui para responder às suas questões e ajudá-la a planear a sessão perfeita para a sua família.',
      form: {
        name: 'Nome',
        email: 'Email',
        phone: 'Telemóvel',
        service: 'Serviço de Interesse',
        selectService: 'Selecione um serviço',
        message: 'Mensagem',
        messagePlaceholder: 'Conte-me mais sobre a sessão que imagina...',
        send: 'Enviar Mensagem',
        sending: 'A enviar...',
        success: 'Mensagem enviada com sucesso! Entrarei em contacto brevemente.',
        error: 'Erro ao enviar mensagem. Por favor, tente novamente.'
      },
      info: {
        location: 'Localização',
        locationValue: 'Atalaia, Montijo',
        email: 'Email',
        phone: 'Telemóvel',
        social: 'Redes Sociais'
      }
    },
    // Booking
    booking: {
      title: 'Agendar Sessão',
      subtitle: 'Escolha a data e hora',
      selectDate: 'Selecione uma data',
      selectTime: 'Horários disponíveis',
      noSlots: 'Sem horários disponíveis',
      yourInfo: 'Os seus dados',
      notes: 'Notas adicionais',
      notesPlaceholder: 'Informações que gostaria de partilhar...',
      confirm: 'Confirmar Marcação',
      confirming: 'A confirmar...',
      success: 'Sessão agendada com sucesso! Entrarei em contacto para confirmar.',
      error: 'Erro ao agendar. Por favor, tente novamente.'
    },
    // Footer
    footer: {
      tagline: 'Capturo momentos, crio memórias.',
      rights: 'Todos os direitos reservados.',
      privacy: 'Política de Privacidade',
      terms: 'Termos e Condições'
    },
    // Temporarily Away
    away: {
      eyebrow: 'Regresso em breve',
      title: 'Estou temporariamente ausente',
      message: 'Encontro-me em formação profissional, a aperfeiçoar a minha arte para trazer ainda mais às vossas próximas sessões. O site regressa muito em breve.',
      contact: 'Para qualquer questão, estou sempre disponível:',
      thanks: 'Obrigada pela sua compreensão. Até já!'
    },
    // Christmas Sessions
    christmas: {
      navLabel: 'Natal',
      eyebrow: 'Edição Especial 2026',
      title: 'Sessões de Natal',
      titleAccent: 'em Estúdio',
      tagline: 'Um cenário especial onde a magia do Natal ganha vida...',
      intro: 'Este ano preparei um cenário de Natal artesanal no estúdio, na Atalaia (Montijo) — luzes quentes, brinquedos de madeira e todo o encanto da época, pensado para fotografias intemporais da sua família.',
      startsLabel: 'Sessões a partir de',
      startsDate: '19 de Outubro de 2026',
      limitedBadge: 'Vagas Limitadas',
      limitedNote: 'As vagas são limitadas e preenchem rapidamente. Garanta já a sua.',
      bookWhatsapp: 'Marcar por WhatsApp',
      bookForm: 'Pedir informações',
      whatsappMessage: 'Olá Vera! Gostaria de marcar uma Sessão de Natal em estúdio. 🎄',
      homeCta: 'Descobrir as Sessões de Natal',
      heroEyebrow: 'Sessões de Natal 2026 · Atalaia, Montijo',
      heroDetails: 'Ver todos os detalhes',
      zoomImage: 'Ver imagem em tamanho maior',
      closeImage: 'Fechar',
      startsDateShort: '19 de Outubro',
      bookingLabel: 'Marcações por WhatsApp',
      highlights: {
        title: 'O que a espera',
        scenario: {
          title: 'Cenário exclusivo',
          description: 'Um cenário de Natal montado ao detalhe no estúdio — árvore iluminada, brinquedos de madeira e tons quentes e acolhedores.'
        },
        families: {
          title: 'Para toda a família',
          description: 'Sessões pensadas para famílias, crianças e bebés. Momentos naturais, sem poses forçadas, com muito espaço para brincar.'
        },
        gift: {
          title: 'O postal perfeito',
          description: 'Fotografias ideais para os postais de Boas Festas, prendas para os avós e memórias que ficam para sempre.'
        },
        delivery: {
          title: 'Entrega antes do Natal',
          description: 'Fotografias editadas ao estilo da minha galeria, entregues a tempo de chegarem debaixo da árvore.'
        }
      },
      details: {
        title: 'Como funciona',
        items: [
          'As sessões decorrem no estúdio, na Atalaia, Montijo — a poucos minutos de Alcochete, Pinhal Novo e Palmela.',
          'Marcações a partir de 19 de Outubro de 2026, enquanto houver vagas.',
          'Cada sessão é individual: o cenário é só para a sua família.',
          'Marcação por WhatsApp ou através do formulário de contacto.'
        ]
      },
      faq: {
        title: 'Perguntas frequentes',
        items: [
          {
            q: 'Onde decorrem as sessões de Natal?',
            a: 'No meu estúdio na Atalaia, Montijo, num cenário de Natal montado em exclusivo para estas sessões — perfeito para famílias do Montijo, Alcochete e arredores.'
          },
          {
            q: 'Quando devo marcar a minha sessão?',
            a: 'As sessões começam a 19 de Outubro de 2026 e as vagas são limitadas. Quanto mais cedo marcar, mais escolha terá de datas e horários.'
          },
          {
            q: 'Recebo as fotografias antes do Natal?',
            a: 'Sim, as sessões são planeadas para que receba as fotografias editadas a tempo das celebrações e dos postais de Boas Festas.'
          },
          {
            q: 'Como posso marcar?',
            a: 'A forma mais rápida é por WhatsApp (913 446 144). Também pode usar o formulário de contacto do site.'
          }
        ]
      },
      seo: {
        title: 'Sessões de Natal em Estúdio 2026 | Vera Hilário Fotografia — Montijo',
        description: 'Sessões fotográficas de Natal em estúdio na Atalaia, Montijo. Cenário exclusivo, vagas limitadas, a partir de 19 de Outubro de 2026. Marcações por WhatsApp.'
      }
    },
    // Vouchers
    vouchers: {
      navLabel: 'Vouchers',
      title: 'Ofereça uma sessão fotográfica',
      subtitle: 'Memórias para sempre',
      intro: 'Ofereça memórias inesquecíveis a quem ama. Escolha o tipo de sessão, personalize o voucher e receba-o no instante.',
      photos: 'fotografias editadas',
      duration: 'Duração',
      buy: 'Comprar voucher',
      perfectGift: 'O presente perfeito',
      validity: 'Válido por 12 meses',
      instant: 'Entrega imediata por email',
      products: {
        family45: { title: 'Sessão de Família', subtitle: '45 minutos · 15 fotografias' },
        family75: { title: 'Sessão de Família', subtitle: '1h15 · 25 fotografias' },
        newborn15: { title: 'Recém-Nascido', subtitle: '2h–2h30 · 15 fotografias' },
        newborn25: { title: 'Recém-Nascido', subtitle: '2h–2h30 · 25 fotografias' },
        maternity: { title: 'Gravidez', subtitle: '45 minutos · 10 fotografias' },
        maternityFamily: { title: 'Gravidez com Família', subtitle: '1h30 · 20 fotografias' },
      },
      checkout: {
        step1: 'Para quem?',
        step2: 'Os seus dados',
        step3: 'Pagamento',
        recipientName: 'Nome de quem vai receber',
        recipientNamePlaceholder: 'Ex: Maria Silva',
        recipientHelp: 'Este nome aparecerá no voucher.',
        message: 'Mensagem pessoal (opcional)',
        messagePlaceholder: 'Uma dedicatória especial...',
        buyerName: 'O seu nome',
        buyerEmail: 'O seu email',
        emailHelp: 'Vamos enviar o voucher para este email.',
        acceptTerms: 'Li e aceito os ',
        termsLink: 'termos e condições',
        continue: 'Continuar',
        back: 'Voltar',
        pay: 'Pagar',
        payAmount: 'Pagar',
        processing: 'A processar...',
        cancel: 'Cancelar',
      },
      success: {
        title: 'Voucher emitido com sucesso',
        subtitle: 'Enviámos uma cópia para o seu email.',
        downloadPdf: 'Descarregar PDF',
        backHome: 'Voltar ao início',
        sendingEmail: 'A preparar o seu voucher...',
      },
      voucher: {
        label: 'VOUCHER',
        forName: 'Para',
        sessionLabel: 'Sessão',
        validUntil: 'Válido até',
        code: 'Código',
        issuedBy: 'Vera Hilário Fotografia',
        atalaia: 'Atalaia, Montijo',
      },
      terms: {
        title: 'Termos e Condições do Voucher',
        items: [
          'Validade: 12 meses a partir da data de compra. Não prorrogável.',
          'Marcação sujeita a disponibilidade. Recomendamos marcar com antecedência mínima de 30 dias.',
          'O voucher não pode ser trocado por dinheiro nem combinado com outras promoções.',
          'Os dados pessoais são tratados nos termos do RGPD.',
          'Aplica-se a legislação portuguesa.',
        ],
      },
      errors: {
        generic: 'Algo correu mal. Por favor, tente novamente.',
        payment: 'Não foi possível concluir o pagamento.',
        loading: 'Não foi possível carregar o voucher.',
      },
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      gallery: 'Gallery',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      book: 'Book Session'
    },
    // Hero
    hero: {
      subtitle: 'Family Photography',
      title: 'Moments that',
      titleAccent: 'come alive',
      description: 'I capture the essence of your family with elegance and sensitivity. Each session is a unique experience, created to preserve precious memories.',
      cta: 'View Portfolio',
      ctaSecondary: 'Book a Session'
    },
    // Services
    services: {
      title: 'Services',
      subtitle: 'What I can do for you',
      family: {
        title: 'Family Sessions',
        description: 'Authentic family moments captured naturally and lovingly. Perfect for creating memories that will last generations.'
      },
      newborn: {
        title: 'Newborn',
        description: 'Your baby\'s first days deserve to be immortalized. Delicate and safe sessions for the little ones.'
      },
      maternity: {
        title: 'Maternity',
        description: 'Celebrate the beauty of motherhood. Elegant sessions that capture this magical moment of your life.'
      },
      baptism: {
        title: 'Baptisms & Communions',
        description: 'Record the special moments of your family\'s religious celebrations with documentary photography.'
      }
    },
    // About
    about: {
      title: 'About Me',
      subtitle: 'My story',
      greeting: 'Hello, I\'m Vera',
      story: `Photography has fascinated me since I was a child. The power to freeze a moment in time, to preserve emotions and create tangible memories has always enchanted me.

A year ago I fulfilled my dream of opening my own studio, and each session continues to move me like the first. I believe the best photographs are born from the genuine connection between the photographer and their clients.

My studio, located in Atalaia, Montijo, is a welcoming space where families can feel free to be authentic. Here, there are no forced poses – just real moments, captured with sensitivity and artistry.

My mission is to create images that tell stories, that move and that will be treasures for future generations. Each family is unique, and my job is to reveal that uniqueness through the lens of my camera.`,
      experience: 'Years of Experience',
      families: 'Families Photographed',
      sessions: 'Sessions Completed',
      dedication: 'Dedication',
      uniqueSession: 'Session is Unique',
      memoriesForever: 'Memories Forever'
    },
    // Gallery
    gallery: {
      title: 'Gallery',
      subtitle: 'My work',
      all: 'All',
      family: 'Family',
      newborn: 'Newborn',
      maternity: 'Maternity',
      baptism: 'Baptisms'
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Let\'s talk',
      intro: 'I\'m here to answer your questions and help you plan the perfect session for your family.',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        service: 'Service of Interest',
        selectService: 'Select a service',
        message: 'Message',
        messagePlaceholder: 'Tell me more about the session you envision...',
        send: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully! I will contact you soon.',
        error: 'Error sending message. Please try again.'
      },
      info: {
        location: 'Location',
        locationValue: 'Atalaia, Montijo, Portugal',
        email: 'Email',
        phone: 'Phone',
        social: 'Social Media'
      }
    },
    // Booking
    booking: {
      title: 'Book Session',
      subtitle: 'Choose date and time',
      selectDate: 'Select a date',
      selectTime: 'Available times',
      noSlots: 'No available slots',
      yourInfo: 'Your information',
      notes: 'Additional notes',
      notesPlaceholder: 'Information you would like to share...',
      confirm: 'Confirm Booking',
      confirming: 'Confirming...',
      success: 'Session booked successfully! I will contact you to confirm.',
      error: 'Error booking. Please try again.'
    },
    // Footer
    footer: {
      tagline: 'Capturing moments, creating memories.',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions'
    },
    // Temporarily Away
    away: {
      eyebrow: 'Back soon',
      title: "I'm temporarily away",
      message: "I'm away for professional training, refining my craft to bring even more to your future sessions. The website will be back very soon.",
      contact: "For any questions, I'm always available:",
      thanks: 'Thank you for your understanding. See you soon!'
    },
    // Christmas Sessions
    christmas: {
      navLabel: 'Christmas',
      eyebrow: 'Special Edition 2026',
      title: 'Christmas Sessions',
      titleAccent: 'in the Studio',
      tagline: 'A special set where the magic of Christmas comes to life...',
      intro: 'This year I have prepared a handcrafted Christmas set in my studio in Atalaia (Montijo) — warm lights, wooden toys and all the charm of the season, designed for timeless photographs of your family.',
      startsLabel: 'Sessions from',
      startsDate: '19 October 2026',
      limitedBadge: 'Limited Spots',
      limitedNote: 'Spots are limited and fill up quickly. Secure yours today.',
      bookWhatsapp: 'Book via WhatsApp',
      bookForm: 'Request information',
      whatsappMessage: 'Hello Vera! I would like to book a Christmas studio session. 🎄',
      homeCta: 'Discover the Christmas Sessions',
      heroEyebrow: 'Christmas Sessions 2026 · Atalaia, Montijo',
      heroDetails: 'See all the details',
      zoomImage: 'View larger image',
      closeImage: 'Close',
      startsDateShort: '19 October',
      bookingLabel: 'Bookings via WhatsApp',
      highlights: {
        title: 'What awaits you',
        scenario: {
          title: 'Exclusive set',
          description: 'A Christmas set built with care in the studio — a glowing tree, wooden toys and warm, cosy tones.'
        },
        families: {
          title: 'For the whole family',
          description: 'Sessions designed for families, children and babies. Natural moments, no forced poses, with plenty of room to play.'
        },
        gift: {
          title: 'The perfect card',
          description: 'Photographs made for your holiday cards, gifts for grandparents and memories that last forever.'
        },
        delivery: {
          title: 'Delivered before Christmas',
          description: 'Photographs edited in my signature style, delivered in time to land under the tree.'
        }
      },
      details: {
        title: 'How it works',
        items: [
          'Sessions take place in my studio in Atalaia, Montijo — minutes from Alcochete, Pinhal Novo and Palmela.',
          'Bookings open from 19 October 2026, while spots last.',
          'Every session is private: the set is yours alone for the duration.',
          'Book via WhatsApp or through the contact form.'
        ]
      },
      faq: {
        title: 'Frequently asked questions',
        items: [
          {
            q: 'Where do the Christmas sessions take place?',
            a: 'In my studio in Atalaia, Montijo, on a Christmas set built exclusively for these sessions — perfect for families from Montijo, Alcochete and nearby.'
          },
          {
            q: 'When should I book my session?',
            a: 'Sessions start on 19 October 2026 and spots are limited. The earlier you book, the more choice of dates and times you will have.'
          },
          {
            q: 'Will I receive the photos before Christmas?',
            a: 'Yes, sessions are planned so you receive your edited photographs in time for the celebrations and holiday cards.'
          },
          {
            q: 'How can I book?',
            a: 'The fastest way is via WhatsApp (913 446 144). You can also use the contact form on the website.'
          }
        ]
      },
      seo: {
        title: 'Christmas Studio Sessions 2026 | Vera Hilário Fotografia — Montijo',
        description: 'Christmas photo sessions in a studio in Atalaia, Montijo. Exclusive set, limited spots, from 19 October 2026. Bookings via WhatsApp.'
      }
    },
    // Vouchers
    vouchers: {
      navLabel: 'Vouchers',
      title: 'Gift a photo session',
      subtitle: 'Memories that last',
      intro: 'Gift unforgettable memories to someone you love. Pick a session, personalize the voucher and receive it instantly.',
      photos: 'edited photos',
      duration: 'Duration',
      buy: 'Buy voucher',
      perfectGift: 'The perfect gift',
      validity: 'Valid for 12 months',
      instant: 'Instant email delivery',
      products: {
        family45: { title: 'Family Session', subtitle: '45 minutes · 15 photos' },
        family75: { title: 'Family Session', subtitle: '1h15 · 25 photos' },
        newborn15: { title: 'Newborn', subtitle: '2h–2h30 · 15 photos' },
        newborn25: { title: 'Newborn', subtitle: '2h–2h30 · 25 photos' },
        maternity: { title: 'Maternity', subtitle: '45 minutes · 10 photos' },
        maternityFamily: { title: 'Maternity & Family', subtitle: '1h30 · 20 photos' },
      },
      checkout: {
        step1: 'Who is it for?',
        step2: 'Your details',
        step3: 'Payment',
        recipientName: 'Recipient name',
        recipientNamePlaceholder: 'e.g. Maria Silva',
        recipientHelp: 'This name will appear on the voucher.',
        message: 'Personal message (optional)',
        messagePlaceholder: 'A special dedication...',
        buyerName: 'Your name',
        buyerEmail: 'Your email',
        emailHelp: 'We will send the voucher to this email.',
        acceptTerms: 'I have read and accept the ',
        termsLink: 'terms and conditions',
        continue: 'Continue',
        back: 'Back',
        pay: 'Pay',
        payAmount: 'Pay',
        processing: 'Processing...',
        cancel: 'Cancel',
      },
      success: {
        title: 'Voucher issued successfully',
        subtitle: 'We have sent a copy to your email.',
        downloadPdf: 'Download PDF',
        backHome: 'Back to home',
        sendingEmail: 'Preparing your voucher...',
      },
      voucher: {
        label: 'VOUCHER',
        forName: 'For',
        sessionLabel: 'Session',
        validUntil: 'Valid until',
        code: 'Code',
        issuedBy: 'Vera Hilário Fotografia',
        atalaia: 'Atalaia, Montijo',
      },
      terms: {
        title: 'Voucher Terms & Conditions',
        items: [
          'Validity: 12 months from the purchase date. Non-extendable.',
          'Booking subject to availability. We recommend booking at least 30 days in advance.',
          'The voucher cannot be exchanged for cash or combined with other promotions.',
          'Personal data is processed under GDPR.',
          'Portuguese law applies.',
        ],
      },
      errors: {
        generic: 'Something went wrong. Please try again.',
        payment: 'Payment could not be completed.',
        loading: 'Could not load voucher.',
      },
    },
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('pt');

  useEffect(() => {
    const savedLang = localStorage.getItem('vh-language');
    if (savedLang && (savedLang === 'pt' || savedLang === 'en')) {
      setLanguage(savedLang);
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'pt' ? 'en' : 'pt';
    setLanguage(newLang);
    localStorage.setItem('vh-language', newLang);
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
